module.exports = __webpack_public_path__ + "img/sara_half.1261db22.png";